// import { useCookies } from "react-cookie";
import jwt_decode from "jwt-decode";
import { googleLogout } from "@react-oauth/google";
import { redirect } from "react-router-dom";
import { fetchFirebaseToken, fetchTPSToken } from "../services/fetchApis";
import { signOut } from "firebase/auth";
import { auth } from "../App";
import { EVENT_NAMES_CONSTANT, logFirebaseEvent } from "../services/events";
import { AUTH_CONSTANTS, LOG_IN_TYPE } from "../constants/auth";

const UserService = () => {
  const handleSuccessfullLogin = async (
    response,
    type = LOG_IN_TYPE.nucleus
  ) => {
    let userId = null;
    let usrObj = null;
    let properties = null;
    if (type === LOG_IN_TYPE.nucleus) {
      userId = response?.user?.id;
      properties = {
        mobile_number: response?.user?.mobile,
        user_role: response?.user?.rolename,
      };
      const expireDate = new Date();
      expireDate.setDate(expireDate.getDate() + 7);
      localStorage.setItem(
        AUTH_CONSTANTS.USER_DATA,
        JSON.stringify(response.user)
      );
      localStorage.setItem(AUTH_CONSTANTS.LOGIN_TYPE, type);
      localStorage.setItem(AUTH_CONSTANTS.AUTH_TOKEN, response.token);
    }

    if (type === LOG_IN_TYPE.google) {
      usrObj = jwt_decode(response.credential);
      userId = usrObj?.email;
      properties = {
        email_id: usrObj?.email,
        user_role: "Guest",
      };
      localStorage.setItem(AUTH_CONSTANTS.LOGIN_TYPE, type);
      localStorage.setItem(AUTH_CONSTANTS.AUTH_TOKEN, response.credential);
      localStorage.setItem(
        AUTH_CONSTANTS.USER_DATA,
        JSON.stringify({ ...usrObj, rolename: "Guest" })
      );
    }
    try {
      const data = await fetchFirebaseToken(
        response?.token || response?.credential,
        type,
        type === LOG_IN_TYPE.nucleus,
        response?.user?.rolename || "guest",
        userId
      );

      console.log("data", data);

      localStorage.setItem(AUTH_CONSTANTS.FIREBASE_DATA, JSON.stringify(data));
      localStorage.setItem(
        AUTH_CONSTANTS.FIREBASE_TOKEN,
        data?._tokenResponse?.idToken
      );

      const tpsToken = await fetchTPSToken();
      if (tpsToken) {
        localStorage.setItem(AUTH_CONSTANTS.TPS_TOKEN, tpsToken);
      }

      // successfull login event
      logFirebaseEvent(EVENT_NAMES_CONSTANT.login_success, {
        login_type: type,
        ...properties,
      });

      redirectToDashboard();
      return response;
    } catch (error) {
      return {
        error: true,
        msg: "Unable to Login",
      };
    }
  };
  const handleLogout = () => {
    localStorage.removeItem(AUTH_CONSTANTS.LOGIN_TYPE);
    localStorage.removeItem(AUTH_CONSTANTS.USER_DATA);
    localStorage.removeItem(AUTH_CONSTANTS.AUTH_TOKEN);
    localStorage.removeItem(AUTH_CONSTANTS.FIREBASE_DATA);
    localStorage.removeItem(AUTH_CONSTANTS.FIREBASE_TOKEN);
    localStorage.removeItem(AUTH_CONSTANTS.TPS_TOKEN);

    if (getLogInType() === "google") googleLogout();

    signOut(auth)
      .then(() => {
        console.log("User signed out");
      })
      .catch((error) => {
        console.error("Error signing out:", error);
      });

    redirect(`/`);
    window.location.reload();
  };

  const setFirebasetoken = (token) => {
    localStorage.setItem(AUTH_CONSTANTS.FIREBASE_TOKEN, token);
  };

  const getTpsToken = () => localStorage.getItem(AUTH_CONSTANTS.TPS_TOKEN);

  const getFirebasetoken = () =>
    localStorage.getItem(AUTH_CONSTANTS.FIREBASE_TOKEN);

  const isLoggedIn = () => !!localStorage.getItem(AUTH_CONSTANTS.AUTH_TOKEN);

  const getUserData = () =>
    JSON.parse(localStorage.getItem(AUTH_CONSTANTS.USER_DATA));


  const getLogInType = () => localStorage.getItem(AUTH_CONSTANTS.LOGIN_TYPE);

  const redirectToDashboard = () => {
    if (isLoggedIn()) {
      redirect(`/schoolData`);
      window.location.reload();
    }
  };

  return {
    handleLogout,
    isLoggedIn,
    getUserData,
    handleSuccessfullLogin,
    getLogInType,
    redirectToDashboard,
    setFirebasetoken,
    getFirebasetoken,
    getTpsToken,
  };
};

export default UserService();
